<template>
  <section>
    <div class="row mt-2">
      <div class="col-md-3"></div>
      <div class="col-md-6 custom-buttons">
        <div class="btn-group" role="group">
          <button
            type="button"
            class="btn btn-primary"
            :class="{ active: selected === 30 }"
            @click="refreshCharts(30)"
          >
            30 days
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ active: selected === 60 }"
            @click="refreshCharts(60)"
          >
            60 days
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ active: selected === 90 }"
            @click="refreshCharts(90)"
          >
            90 days
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ active: selected === 180 }"
            @click="refreshCharts(180)"
          >
            180 days
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :class="{ active: selected === 365 }"
            @click="refreshCharts(365)"
          >
            365 days
          </button>
        </div>
      </div>
      <div class="col-md-3"></div>
    </div>
    <div class="row mt-2">
      <div class="col-md-6">
        <span>Weight History</span>
        <bodyweight-chart />
      </div>
      <div class="col-md-6">
        <span>Body Fat History</span>
        <bodyfat-chart />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import BodyfatChart from '@/Components/UserCardio/elements/bodyfat-chart'
import BodyweightChart from '@/Components/UserCardio/elements/bodyweight-chart'
export default {
  name: 'bodycomp-charts',
  components: {
    BodyfatChart,
    BodyweightChart,
  },
  data() {
    return {
      selected: 30,
    }
  },
  mounted() {
    this.selected = 30
  },
  computed: {
    ...mapGetters('bodycomposition', ['bodycomposition']),
  },
  methods: {
    ...mapActions('bodycomposition', [
      'getBodyFatChartValues',
      'getBodyWeightChartValues',
    ]),
    async refreshCharts(days) {
      console.log('Refreshing Charts', days)
      this.selected = days
      let data = {
        id: this.bodycomposition.id,
        span: days,
        date: this.bodycomposition.startDate,
      }
      await this.getBodyFatChartValues(data)
      await this.getBodyWeightChartValues(data)
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-buttons {
  text-align: center;
}
</style>
